import {html} from '../lib/lit-html.js';
import {SearchResultState} from '../searchresultstate.js';

export function searchPageHeader(state){
	var heading = '';
	var showing = '';

	if (state.search.state !== SearchResultState.UNLOADED){
		let {query, totalItems} = state.search;
		heading = `Showing Results for "${query}"`;
		showing = `${totalItems} product${(totalItems > 1)?'s':''} found`;
	}

	if (state.search.state === SearchResultState.LOADING){
		showing = 'Loading...';
	}

	return html`
		<div class="ekm-search-page-header">
			<h1>${ heading }</h1>
			<div class="ekm-search-page-header-showing">${ showing }</div>
		</div>
	`;
}